import React from 'react';
import {
  SimpleGrid,
  Card,
  CardBody,
  Stat,
  StatLabel,
  StatNumber,
  Text,
  Spinner,
  Flex,
} from '@chakra-ui/react';
import { IRegimeEspecialKpis } from '../../../../../../types/regimeEspecial';
import { formatCurrency, toNumber } from '../../../../../../utils/FormatFunctions';

interface RegimesEspeciaisKpisProps {
  data?: IRegimeEspecialKpis;
  isLoading?: boolean;
}

export function RegimesEspeciaisKpis({ data, isLoading }: RegimesEspeciaisKpisProps) {
  if (isLoading && !data) {
    return (
      <Flex justify="center" py={4}>
        <Spinner color="primary" />
      </Flex>
    );
  }
  if (!data) return null;

  return (
    <SimpleGrid columns={{ base: 2, md: 3, lg: 6 }} spacing={3} mb={4}>
      <Card>
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.500" textTransform="uppercase" fontWeight="bold">
              Total
            </StatLabel>
            <StatNumber fontSize="22px">{data.total}</StatNumber>
          </Stat>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#10b981">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.500" textTransform="uppercase" fontWeight="bold">
              Ativos
            </StatLabel>
            <StatNumber fontSize="22px" color="#10b981">
              {data.ativos}
            </StatNumber>
          </Stat>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#f59e0b">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.500" textTransform="uppercase" fontWeight="bold">
              Suspensos
            </StatLabel>
            <StatNumber fontSize="22px" color="#f59e0b">
              {data.suspensos}
            </StatNumber>
          </Stat>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#ef4444">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.500" textTransform="uppercase" fontWeight="bold">
              Encerrados
            </StatLabel>
            <StatNumber fontSize="22px" color="#ef4444">
              {data.encerrados}
            </StatNumber>
          </Stat>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#fb923c">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.500" textTransform="uppercase" fontWeight="bold">
              Vencendo &lt; 90d
            </StatLabel>
            <StatNumber fontSize="22px" color="#fb923c">
              {data.a_vencer_em_90_dias}
            </StatNumber>
          </Stat>
        </CardBody>
      </Card>
      <Card borderLeft="4px solid" borderLeftColor="#5d7fff">
        <CardBody p={4}>
          <Stat>
            <StatLabel fontSize="11px" color="gray.500" textTransform="uppercase" fontWeight="bold">
              Economia estimada
            </StatLabel>
            <StatNumber fontSize="16px" color="#5d7fff">
              {formatCurrency(toNumber(data.economia_estimada_total))}
            </StatNumber>
            {data.por_esfera && (
              <Text fontSize="10px" color="gray.500" mt={1}>
                F:{data.por_esfera.federal ?? 0} · E:{data.por_esfera.estadual ?? 0} · M:
                {data.por_esfera.municipal ?? 0}
              </Text>
            )}
          </Stat>
        </CardBody>
      </Card>
    </SimpleGrid>
  );
}
